import { Card } from "@/components/ui/card";
import { TimeProjectionResult } from "@/types/calculator";
import { Calendar, TrendingDown, Flame, Activity } from "lucide-react";

interface TimeProjectionsProps {
  projections: TimeProjectionResult[];
}

const TimeProjections = ({ projections }: TimeProjectionsProps) => {
  return (
    <Card className="p-4 border-card-border rounded-2xl shadow-soft">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="w-5 h-5 text-primary" />
        <h3 className="text-sm font-semibold text-foreground">Time Projections</h3>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {projections.map((proj) => (
          <div 
            key={proj.period}
            className="bg-secondary/50 p-3 rounded-xl border border-card-border hover:bg-secondary transition-colors"
          >
            <p className="text-xs font-medium text-muted-foreground mb-2">{proj.label}</p>
            
            <div className="space-y-2">
              <div className="flex items-center gap-1">
                <TrendingDown className="w-3 h-3 text-accent" />
                <span className="text-sm font-bold text-accent">
                  -{proj.totalWeightChange.toFixed(1)} kg
                </span>
              </div>
              
              <div className="flex items-center gap-1">
                <Flame className="w-3 h-3 text-primary" />
                <span className="text-xs text-muted-foreground">
                  {Math.round(proj.totalCalories).toLocaleString()} kcal
                </span>
              </div>
              
              <div className="flex items-center gap-1">
                <Activity className="w-3 h-3 text-foreground" />
                <span className="text-xs text-muted-foreground">
                  {proj.sessions} sessions
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TimeProjections;
